angular.module('common.directives').directive('edgeList', function () {
  return {
    templateUrl: './templates/edgeList.depracated.view.html?t=' + webpackHash,
    controller: 'edgeListControllerDeprecated',
    link: function ($scope, $element, attributes, $interval) {
      $scope.$on('$destroy', function handleDestroyEvent () {
        $scope.stopPing()
      })
    }
  }
})
